export default {
    
    find:   { method: 'get',    url: 'banks' },
    create: { method: 'post',   url: 'banks'},
    update: { method: 'put',    url: 'banks/{id}'},
    delete: { method: 'delete', url: 'banks/{id}'}
}